module.exports = __webpack_public_path__ + "img/river-lariviere.08344c31.png";